module.exports = __webpack_public_path__ + "static/media/icon-envelope.edde884a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icon-envelope.svg
// module id = 1990
// module chunks = 0